<mat-form-field appearance="outline">
  <mat-label *ngIf="hasValue(title)">{{ title }}</mat-label>
  <input matInput [matDatepicker]="picker" [formControl]="control" />
  <mat-hint *ngIf="hasValue(hint)">{{ hint }}</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
